import React from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";

class Mickey3 extends React.Component {
  /*Scroll to top of page at init*/
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>
            RPGONE Translations - Magical Quest 3 - starring Mickey & Donald -
            English Translation v1.5 SNES - ミッキーとドナルド
            マジカルアドベンチャー３
          </title>
          <meta
            name="title"
            content="RPGONE Translations - Magical Quest 3 - starring Mickey & Donald - English Translation v1.5 SNES - ミッキーとドナルド マジカルアドベンチャー３"
          />
          <meta
            name="description"
            content="English Translation v1.5 - The evil King Pete is up to his old tricks again. When the guardian fairy of Storybook Land fell asleep, King Pete and his minions took it over and are now plotting to take over the real world aswell - Magical Quest 3 starring Mickey & Donald for the SNES / Super Famicom / Super Nintendo by RPGONE Translations"
          />
        </Helmet>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <span className="title-centered">
                {/*<h3>Magical Quest 3 - starring Mickey & Donald - English Translation</h3>
            <i><div>ミッキーとドナルド マジカルアドベンチャー３</div></i>*/}
              </span>
              <div className="center-image">
                <img
                  src={require("./img/mickey3_english_1.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/mickey3e_00034.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/mickey3e_00005.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/mickey3e_00008.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/mickey3e_00001.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/mickey3e_00013a.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/mickey3e_00015.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/mickey3e_00007.png")}
                  alt=""
                  className="imageResize"
                />
                <br />
                <br />
                <i>
                  <div>
                    Magical Quest 3 starring Mickey & Donald<br />Original
                    release: 8th December 1995 on Super Famicom (Snes / Super
                    Nintendo)
                  </div>
                </i>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Story</div>
              </b>
              <br />
              The evil King Pete is up to his old tricks again. When the
              guardian fairy of Storybook Land fell asleep, King Pete and his
              minions took it over and are now plotting to take over the real
              world aswell. Not only that, Pete has kidnapped Donald's nephews
              Huey, Dewey and Louie to use as his slaves.<br />
              <br />
              Now that Mickey and Donald have found out about King Pete's
              terrible plans, will they be able to save Donald's nephews and
              restore peace to Storybook Land before it's too late?
              <br />
              <br />
              <div className="center-image">
                <a href={require("./img/box/Magical Quest 3 - Box Cover.jpg")}>
                  <img
                    src={require("./img/box/Magical Quest 3 - Box Cover.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>{" "}
                <a href={require("./img/box/Magical Quest 3 - Box Back.jpg")}>
                  <img
                    src={require("./img/box/Magical Quest 3 - Box Back.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Downloads</div>
              </b>
              <br />
              <a
                href={require("./files/Magical Quest 3 - English v1.5.zip")}
                download="Magical Quest 3 - English v1.5.zip"
              >
                English Translation patch v1.5
              </a>{" "}
              by RPGONE
              <br />
              <br />
	      <a
                href={require("./files/Magical Quest 3 - Portuguese v1.0.zip")}
                download="Magical Quest 3 - Portuguese v1.0.zip"
              >
                Portuguese Translation patch v1.0
              </a>{" "}
              by Goro's Lair
              <br />
              <br />
              <a href="https://traduccionessemco.blogspot.com/2018/12/traduccion-magical-quest-3-starring.html">
                Spanish Translation patch v1.4
              </a>{" "}
              by Semco
	      <br />
              <br />
              <a href="https://www.romhacking.net/translations/5907/">
                Swedish Translation patch v1.0
              </a>{" "}
              by Mattiac
              <br />
              <br />
              <a
                href={require("./files/Magical Quest 3 - Nephew Colors hack.zip")}
                download="Magical Quest 3 - Nephew Colors hack.zip"
              >
                Nephew Colours Hack patch
              </a>{" "}
              - Change nephews to their usual colors
              <br />
              <br />
              <a
                href={require("./files/Magical Quest 3 - No Letterbox hack.zip")}
                download="Magical Quest 3 - No Letterbox hack.zip"
              >
                No Letterbox Hack patch
              </a>{" "}
              - Remove black border at top and bottom of screen
              <br />
              <br />
              <a
                href={require("./files/Magical Quest 3 (Nightfall) Trainer.zip")}
                download="Magical Quest 3 (Nightfall) Trainer.zip"
              >
                Nightfall Cheat patch
              </a>{" "}
              - Made in 1996
              <br />
              <br />
              <a href="http://www.romhacking.net/translations/553/">
                Project page on romhacking.net
              </a>
              <br />
              <br />
              <a href="https://muuseo.com/SFC/items/31">
                Prototype cart dated August 31 1995
                (https://muuseo.com/SFC/items/31)
              </a>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Nephew Colors Hack</div>
              </b>
              <br />
              <i>
                Disney archivist Dave Smith once said, “Note that the brightest
                hue of the three is red (Huey), the color of water, dew, is blue
                (Dewey), and that leaves Louie, and leaves are green.”
              </i>
              <br />
              <br />
              <b>
                Hack to change Donald’s nephews to their well known colors -
                Huey is red, Dewey is blue and Louie is green.
              </b>
              <br />
              <br />(Originally in the game, Huey was blue, Dewey was green and
              Louie was red).
              <br />
              <br />
              <div className="center-image">
                <br />
                <img
                  src={require("./img/mickey3e_00010.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/mickey3e_00002_nephew_colors_hack.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/mickey3e_00003_nephew_colors_hack.png")}
                  alt=""
                  className="imageResize"
                />
              </div>
              <br />
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>No Letterbox Hack</div>
              </b>
              <br />
              The letterbox is the black border drawn at the top and bottom of
              the screen. It was added by the developer to allow more processes
              to be carried out without slowdown.<br />The first Magical Quest
              game in the series didn't have a letterbox, and it looks much
              better not having a black border covering parts of the stage. The
              letterbox is primarily required when Mode-7 is being used such as
              for Bosses. Mode-7 is used for a number of boss characters instead
              of sprites, eg Stage 1-4 Flying Pig boss, or Stage 2-5 Spider
              boss, which allows for full rotation of the boss.
              <br />
              <br />
              The letterbox is still enabled on the following stages:<br />
              <b>
                Stage 1-4 Flying Pig boss, Stage 2-5 Spider boss, Stage 3-4
                Snake boss, Stage 4-1, Stage 4-4 Pirate boss, Stage 5-3 Octopus
                boss
              </b>
              <br />
              <br />
              <div className="center-image">
                <b>Left is before with letterbox, right is without letterbox</b>
                <br />
                <img
                  src={require("./img/mickey3_letterbox1.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/mickey3_no_letterbox1.png")}
                  alt=""
                  className="imageResize"
                />
              </div>
              <br />
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>PAR Codes</div>
              </b>
              <br />
              <br />
              <b>7E0A6F 00</b> - Most bosses take 1 hit to defeat<br />
              <b>7E136F 00</b> - Stage 2-5 boss 1 hit to defeat<br />
              <b>7E0B6F 00</b> - Stage 3-5 boss 1 hit to defeat<br />
              <br />
              <code-container>
                <row-section>
                  <b>7E008E</b>
                </row-section>
                <row-section>
                  <b>XX</b>
                </row-section>
                <row-section>
                  <b>- Level Select</b> - <i>Enter on world map</i>
                </row-section>

                <row-section />
                <row-section-leftpadding>00</row-section-leftpadding>
                <row-section>- Test Stage</row-section>

                <row-section />
                <row-section-leftpadding>01</row-section-leftpadding>
                <row-section>- Level 1-1</row-section>

                <row-section />
                <row-section-leftpadding>02</row-section-leftpadding>
                <row-section>- Level 1-2</row-section>

                <row-section />
                <row-section-leftpadding> etc</row-section-leftpadding>
                <row-section />
              </code-container>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Mickey3);



// WEBPACK FOOTER //
// ./src/Mickey3.js